module.exports = __webpack_public_path__ + "media/images/icons/filled/google-circle-2bd873d9c939cbe4a9a692248a211d76.svg";